import { Image as ImageIcon } from "lucide-react";

export function PostPreview({ platform, content, media, accountInfo, cover }) {
  const handle = accountInfo?.username || "tuocliente";
  const avatar = accountInfo?.profile_picture_url;
  const firstImg = media?.find(m => !m.mime?.startsWith("video/"));
  const firstVid = media?.find(m => m.mime?.startsWith("video/"));
  // Quando c'è video + cover, mostra la cover come thumbnail; altrimenti fallback all'immagine principale
  const mainMedia = firstVid && cover ? { ...cover, _isCoverOverVideo: true } : (firstImg || firstVid);

  if (platform === "instagram") {
    return (
      <div className="w-full max-w-[280px] bg-white border rounded-lg overflow-hidden shadow-sm" data-testid="preview-instagram">
        <div className="flex items-center gap-2 p-2.5 border-b">
          {avatar ? <img src={avatar} alt="" className="w-7 h-7 rounded-full" /> : <div className="w-7 h-7 rounded-full bg-gradient-to-br from-fuchsia-500 to-orange-400" />}
          <div className="text-xs font-semibold flex-1">{handle}</div>
          <div className="text-xs text-slate-400">•••</div>
        </div>
        <div className="aspect-square bg-slate-100 flex items-center justify-center">
          {mainMedia ? (
            mainMedia._isCoverOverVideo ? <img src={mainMedia.url} alt="" className="w-full h-full object-cover" /> :
            mainMedia.mime?.startsWith("video/") ? <div className="text-slate-500 text-xs">▶ VIDEO</div> : <img src={mainMedia.url} alt="" className="w-full h-full object-cover" />
          ) : <ImageIcon className="w-10 h-10 text-slate-300" />}
        </div>
        <div className="p-2.5">
          <div className="flex gap-3 mb-1.5">
            <span className="text-base">♡</span><span className="text-base">💬</span><span className="text-base">↗</span>
          </div>
          <div className="text-xs"><span className="font-semibold">{handle}</span> {content || <span className="text-slate-400 italic">Anteprima del testo del post...</span>}</div>
          <div className="text-[10px] text-slate-400 mt-1">qualche secondo fa</div>
        </div>
      </div>
    );
  }

  if (platform === "facebook") {
    return (
      <div className="w-full max-w-[300px] bg-white border rounded-lg overflow-hidden shadow-sm" data-testid="preview-facebook">
        <div className="flex items-center gap-2 p-2.5">
          {avatar ? <img src={avatar} alt="" className="w-9 h-9 rounded-full" /> : <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-blue-700" />}
          <div className="flex-1">
            <div className="text-xs font-semibold">{handle}</div>
            <div className="text-[10px] text-slate-500">In programmazione · 🌐</div>
          </div>
        </div>
        <div className="px-2.5 pb-2 text-xs leading-relaxed">{content || <span className="text-slate-400 italic">Anteprima testo Facebook...</span>}</div>
        {mainMedia && (
          <div className="bg-slate-100">
            {mainMedia.mime?.startsWith("video/") ? <div className="aspect-video flex items-center justify-center text-slate-500 text-xs">▶ VIDEO</div> : <img src={mainMedia.url} alt="" className="w-full max-h-72 object-cover" />}
          </div>
        )}
        <div className="grid grid-cols-3 border-t text-[11px] text-slate-600">
          <div className="py-1.5 text-center hover:bg-slate-50">👍 Mi piace</div>
          <div className="py-1.5 text-center hover:bg-slate-50">💬 Commenta</div>
          <div className="py-1.5 text-center hover:bg-slate-50">↗ Condividi</div>
        </div>
      </div>
    );
  }

  if (platform === "youtube") {
    return (
      <div className="w-full max-w-[300px] bg-white border rounded-lg overflow-hidden shadow-sm" data-testid="preview-youtube">
        <div className="aspect-video bg-slate-900 flex items-center justify-center relative">
          {mainMedia ? (
            mainMedia.mime?.startsWith("video/") ? <div className="text-white text-xs">▶ VIDEO</div> : <img src={mainMedia.url} alt="" className="w-full h-full object-cover" />
          ) : <div className="text-white text-2xl">▶</div>}
        </div>
        <div className="flex gap-2 p-2.5">
          {avatar ? <img src={avatar} alt="" className="w-9 h-9 rounded-full" /> : <div className="w-9 h-9 rounded-full bg-red-600 flex items-center justify-center text-white text-xs font-bold">YT</div>}
          <div className="flex-1 min-w-0">
            <div className="text-xs font-semibold line-clamp-2">{content?.split("\n")[0] || <span className="text-slate-400 italic">Titolo video da contenuto...</span>}</div>
            <div className="text-[10px] text-slate-500 mt-0.5">{handle} · in programmazione</div>
            <div className="text-[10px] text-slate-500">0 visualizzazioni</div>
          </div>
        </div>
      </div>
    );
  }

  if (platform === "tiktok") {
    return (
      <div className="w-full max-w-[240px] aspect-[9/16] bg-black rounded-2xl overflow-hidden relative shadow-sm" data-testid="preview-tiktok">
        {mainMedia ? (
          mainMedia._isCoverOverVideo ? <img src={mainMedia.url} alt="" className="w-full h-full object-cover" /> :
          mainMedia.mime?.startsWith("video/") ? <div className="w-full h-full bg-slate-800 flex items-center justify-center text-white text-xs">▶ VIDEO</div> : <img src={mainMedia.url} alt="" className="w-full h-full object-cover opacity-90" />
        ) : <div className="w-full h-full bg-gradient-to-br from-slate-700 to-black" />}
        <div className="absolute right-2 bottom-12 flex flex-col gap-3 items-center">
          <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white">♡</div>
          <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white">💬</div>
          <div className="w-8 h-8 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white">↗</div>
        </div>
        <div className="absolute bottom-2 left-2 right-12 text-white">
          <div className="text-xs font-bold">@{handle}</div>
          <div className="text-[10px] mt-0.5 line-clamp-3">{content || <span className="text-white/60 italic">Anteprima caption TikTok...</span>}</div>
        </div>
      </div>
    );
  }
  return null;
}
